import { Box } from '@chakra-ui/react'
import { Page } from 'components/Layout/Page'
import { Text } from 'components/Text'

export const LiquidityPools = () => {
  return (
    <Page>
      <Box width='full'>
        <Text translation='defi.liquidityPools' />
      </Box>
    </Page>
  )
}
